"use strict";
export class QuickSearchController {
  constructor(host) {
    this.host = host;
    this.host.addController(this);
  }
  hostConnected() {
  }
  getSearchServiceUrl(quickSearchUrl, searchTerm, filter = "all") {
    const params = new URLSearchParams({
      term: searchTerm,
      size: "50",
      from: "0"
    });
    this.addFilterParams(params, filter);
    return `${quickSearchUrl}?${params.toString()}`;
  }
  addFilterParams(params, filter) {
    const enabledFilters = filter === "all" ? /* @__PURE__ */ new Set(["prospect", "contact", "household", "organization"]) : /* @__PURE__ */ new Set([filter]);
    const filterValues = {
      prospects_search: enabledFilters.has("prospect"),
      contacts_search: enabledFilters.has("contact"),
      households_search: enabledFilters.has("household"),
      organizations_search: enabledFilters.has("organization")
    };
    Object.entries(filterValues).forEach(([key, value]) => {
      params.append(key, String(value));
    });
  }
  fetchResults(quickSearchUrl, searchTerm, headers, filter = "all") {
    if (this.abortController instanceof AbortController && !this.abortController.signal.aborted) {
      this.abortController.abort();
    }
    if (!searchTerm) {
      return Promise.resolve([]);
    }
    this.abortController = new AbortController();
    return fetch(this.getSearchServiceUrl(quickSearchUrl, searchTerm, filter), {
      headers,
      signal: this.abortController.signal
    }).then(this.handleResponse).then(this.mapResponseToResults).catch(this.handleError);
  }
  handleResponse(response) {
    if (response.status === 200) {
      return response.json();
    } else {
      throw new Error("Something went wrong on the server.");
    }
  }
  mapResponseToResults(responseJson) {
    return responseJson.map((item) => {
      return {
        title: item.display_value,
        value: item.url
      };
    });
  }
  handleError(error) {
    if (error.name === "AbortError") {
      return [];
    }
    throw error;
  }
}
